import ZoomServices from "../../../services/ZoomServices";

const ZoomProvider = {
  // Returns a truthy connection marker (never a real token — Zoom tokens live server-side).
  async getValidAccessToken() {
    const status = await ZoomServices.getConnectionStatus();
    return status?.connected ? true : null;
  },

  async createMeeting(payload) {
    const connected = await this.getValidAccessToken();
    if (!connected) throw new Error("Zoom not authenticated");

    return ZoomServices.createUserMeeting(payload);
  },

  async updateMeeting(meetingId, payload) {
    const connected = await this.getValidAccessToken();
    if (!connected) throw new Error("Zoom not authenticated");

    return ZoomServices.updateUserMeeting(meetingId, payload);
  },

  async getUpcomingMeetings() {
    return ZoomServices.getUpcomingMeetings();
  },

  async deleteMeeting(meetingId) {
    return ZoomServices.deleteMeeting(meetingId);
  },

  async deleteExpiredMeetings() {
    return ZoomServices.deleteExpiredMeetings();
  },

  getName() {
    return "Zoom";
  }
};

export default ZoomProvider;
